// src/pages/AboutUs.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ShieldCheck, Users, Lightbulb, Globe } from 'lucide-react';
import AnimatedCounter from '../components/AnimatedCounter'; 
import '../components/css/AboutUs.css';
import janet from '../assets/img/janet.jpeg';
import Anant from '../assets/img/Anant.jpeg';
import Ashutosh from '../assets/img/Ashutosh.jpeg';

const AboutUs = () => {
  return (
    <div className="about-page-wrapper">
      {/* HERO SECTION */}
      <section className="about-hero">
        <Container className="text-center">
          <h1 className="about-hero-title">About Us</h1>
          <p className="about-hero-subtitle">
            Connecting talented performers with verified casting opportunities worldwide.
          </p>
        </Container>
      </section>

      {/* STORY SECTION */}
      <section className="about-story-section">
        <Container>
          <p>
            BookMyAudition is the premier platform revolutionizing how talent and casting professionals connect. We leverage AI-powered matching, smart scheduling, and modern tools to simplify auditions.
          </p>
          <p>
            Founded by industry professionals, we solve real problems like fake auditions, scheduling conflicts, and geographical limitations. Today, we serve thousands of performers and casting professionals worldwide.
          </p>
        </Container>
      </section>

      {/* VALUES SECTION */}
      <section className="about-values-section">
        <Container>
          <h2 className="about-section-title">Our Values</h2>
          {/* Using xs={6} for 2 in a row on mobile, md={3} for 4 in a row on desktop */}
          <Row className="g-4">
            <Col lg={3} md={6} xs={6}>
              <div className="about-value-card">
                <div className="about-value-icon-box"><ShieldCheck size={28}/></div>
                <h4 className="about-value-title">Trust & Safety</h4>
                <p className="about-value-text">All casting professionals are verified.</p>
              </div>
            </Col>
            <Col lg={3} md={6} xs={6}>
              <div className="about-value-card">
                <div className="about-value-icon-box"><Users size={28}/></div>
                <h4 className="about-value-title">Community First</h4>
                <p className="about-value-text">We build features based on real user needs.</p>
              </div>
            </Col>
            <Col lg={3} md={6} xs={6}>
              <div className="about-value-card">
                <div className="about-value-icon-box"><Lightbulb size={28}/></div>
                <h4 className="about-value-title">Innovation</h4>
                <p className="about-value-text">AI tools and smart scheduling.</p>
              </div>
            </Col>
            <Col lg={3} md={6} xs={6}>
              <div className="about-value-card">
                <div className="about-value-icon-box"><Globe size={28}/></div>
                <h4 className="about-value-title">Global Access</h4>
                <p className="about-value-text">Connecting talent worldwide.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* TEAM SECTION */}
      <section className="about-team-section">
        <Container>
          <h2 className="about-section-title">Meet The Founders</h2>
          <Row className="g-4 justify-content-center">
            {/* xs={12} forces 1 column per row on mobile */}
            {/* Janet */}
            <Col lg={4} md={6} xs={12} className="d-flex align-items-stretch">
              <div className="about-team-card">
                <div className="about-team-img-wrapper">
                  <img src={janet} alt="Janet - Co-Founder" className="about-team-img" />
                </div>
                <div className="about-team-content">
                  <h4 className="about-team-name">Janet</h4>
                  <span className="about-team-role">Co-Founder</span>
                  <p className="about-team-bio">
                    Arguably one of the biggest names in the casting circuit of Television Serials, Janet brings unparalleled industry expertise and connections to the team.
                  </p>
                </div>
              </div>
            </Col>

            {/* Anant */}
            <Col lg={4} md={6} xs={12} className="d-flex align-items-stretch">
              <div className="about-team-card">
                <div className="about-team-img-wrapper">
                  <img src={Anant} alt="Anant Ganediwal - Founder" className="about-team-img" />
                </div>
                <div className="about-team-content">
                  <h4 className="about-team-name">Anant Ganediwal</h4>
                  <span className="about-team-role">Founder</span>
                  <p className="about-team-bio">
                    An avid investor with crystal-clear thinking, Anant's financial engineering skills ensure the venture stays on the cutting edge while keeping the 'Vitamin M' (Money) in check.
                  </p>
                </div>
              </div>
            </Col>
            
            {/* Ashutosh */}
            <Col lg={4} md={6} xs={12} className="d-flex align-items-stretch">
              <div className="about-team-card">
                <div className="about-team-img-wrapper">
                   <img src={Ashutosh} alt="Ashutosh Jha - Founder" className="about-team-img" />
                </div>
                <div className="about-team-content">
                  <h4 className="about-team-name">Ashutosh Jha</h4>
                  <span className="about-team-role">Founder</span>
                  <p className="about-team-bio">
                    As a technical founder, Ashu's focus is on leveraging technology to create an unfair advantage, turning the dream of a seamless audition process into reality.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- STATS SECTION --- */}
      <section className="about-stats-section">
        <Container>
          <h2 className="about-section-title">Join Our Growing Community</h2>
          {/* Changed g-5 to g-2 on mobile so they don't break the layout */}
          <Row className="g-2 g-md-5 text-center justify-content-center">
            
            {/* xs={4} forces 3 columns in 1 row on mobile */}
            <Col xs={4} md={4}>
              <div className="about-stat-number d-flex justify-content-center">
                <AnimatedCounter endValue={50000} />+
              </div>
              <div className="about-stat-label">Active Talent</div>
            </Col>
            
            <Col xs={4} md={4}>
              <div className="about-stat-number d-flex justify-content-center">
                <AnimatedCounter endValue={5000} />+
              </div>
              <div className="about-stat-label">Casting Pros</div>
            </Col>
            
            <Col xs={4} md={4}>
              <div className="about-stat-number d-flex justify-content-center">
                <AnimatedCounter endValue={100000} />+
              </div>
              <div className="about-stat-label">Auditions</div>
            </Col>

          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AboutUs;